import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MFASetupPage } from './MFASetupPage';

export function RegisterMFAPage() {
	const navigate = useNavigate();
	const location = useLocation();

	// Get data from navigation state
	const { userId, qrCodeDataURL } = location.state || {};

	useEffect(() => {
		if (!userId || !qrCodeDataURL) {
			// Missing required parameters, redirect to registration
			navigate('/auth/register');
		}
	}, [userId, qrCodeDataURL, navigate]);

	return <MFASetupPage />;
}
